import React from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { PageLayoutError } from "../../components/PageLayout";
import ErrorOnboarding from "../../components/ErrorOnboarding";

const ErrorPage = (props) => {
  return (
    <PageLayoutError>
      <ErrorOnboarding 
        errorCode={'500'}
        errorHeading={'Something Went Wrong'}
      >
        <Typography variant="body1" component="p">
          The page that you requested encountered something horrible. We are trying to fix it.
        </Typography>
        <Button variant="contained" color="primary" component={Link} to="/">
          Go to Dashboard
        </Button>
      </ErrorOnboarding>
    </PageLayoutError>
  );
};

export default ErrorPage;
